module.exports = __webpack_public_path__ + "img/dots-vertical.a4bb72c3.svg";